import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import BookingService from './../../../services/cargobooking.service';
import Util from './../../../../shared/util/util';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import MasterService from './../../../../masterdata/services/masterdata.service';

export default {
  name: 'pendingPushToManifestBookingList',
  components: {
    VueElementLoading,
    Pagination,
    DatePicker,
    CustomExpandableTable,
  },
  data: function() {
    return {
      tableColumn:['AWB Number','Booking Date','Booking Method','Booking Status','Last Modified By','Last Modified Date','Push Manifest Response','Action'],
      tableItems:[],
      awbNoSearch:'',
      AWBNumber:'',
      isLoading:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      userName:'',
      pageLimit:CONSTANT.PER_PAGE_DATA,
    }
  },
  computed: {

  },
  async mounted() {
    this.isLoading = true;
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    await Promise.all([
    this.GetPendingPushToManifestBookingList()]);
    this.isLoading = false;
 },
  methods:{
  onPageChange(page) {
    this.currentPage = page;
    this.offset = (page - 1) * this.pageLimit
    this.GetPendingPushToManifestBookingList();
  },
  searchAWB(){
    this.currentPage = 1;
    this.offset = 0;
    this.GetPendingPushToManifestBookingList();
  },
  resetSearch(){
    this.AWBNumber='';
    this.GetPendingPushToManifestBookingList();
  },
  async GetPendingPushToManifestBookingList(){
    try {
      this.isLoading = true;
      let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
      }
      if(this.AWBNumber!=""){
        inputPayload.awbnumber = this.AWBNumber;
      }
      let allResolved = await Promise.all([BookingService.GetPendingPushToManifestBookingList(inputPayload)])
      let result = allResolved[0]
      this.tableArr = result.data.data.rows;
      this.totalCount = result.data.data.count;
      if(this.totalCount>0){
        this.tableItems = result.data.data.rows.map((el)=>{
          return {
            'id': el.id,
            'AWB Number':el.awbnumber,
            'Booking Date': Util.displayDateOnlyFormat(el.bookingdate),
            'Booking Method':el.bookingmethod,
            'Booking Status':el.bookingstatus,
            'Last Modified By':el.lastmodifiedby,
            'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
            'Push Manifest Response':el.pushmanifestresponse,
            'Action':'Need To Check1'
          }
        })
      }else{
        this.tableItems = [];
      }
      if (this.totalCount < this.pageLimit) {
        this.totalPage = 1
      } else {
        this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
      }
      this.isLoading = false;
      }
      catch(err){
      console.log(err);
      this.isLoading = false;
    }
  },
  async resyncToManifest(resyncid){
    try {
      this.isLoading = true;
      let inputPayload = {
        'BookingId': resyncid,
        "lastmodifiedby":this.userName
      }
      let result = await BookingService.pushBookingDatatoManifest(inputPayload)
      if(result.data.code == 200){
        this.$alert(result.data.message, this.AWBNumber, "success");
        this.currentPage = 1;
        this.isLoading = false;
      }
      else{
        this.$alert(result.data.message, this.AWBNumber, "error");
        this.currentPage = 1;

      }
    } catch(err){
      console.log(err);
    }
      this.isLoading = false;
   },
  getCustomTableEvent(event) {
     if (event.actionType == "resync") {
       console.log("Event.id - "+event.id);
       this.$confirm("Are you sure you want to resync this booking with Manifest?","","question").then(() => {
         this.resyncToManifest(event.id);
      }).catch((err)=>{
        console.log(err)
      });
     }
   },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/pushpendingshipments/pendingawb/pendingawb.component.js